import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { openTool } from "./Nav";
import { CONTACT, TOOLS } from "@/data/site";
import { scrollToId } from "@/lib/scroll";

const COMPANY = [
  { label: "How it works", id: "how" },
  { label: "Pricing", id: "pricing" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];
const item = "block text-sm text-slate-300 hover:text-white transition-colors py-1.5";
const head = "font-display text-xs font-semibold tracking-[0.18em] uppercase mb-4";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 lg:grid-cols-12 gap-10">
      <div className="col-span-2 lg:col-span-5">
        <Logo testId="footer-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} />
        <p className="mt-5 text-sm text-slate-300 max-w-xs">AI photo tools for cars, bikes and people. Change the scene, keep the moment.</p>
        <div className="mt-5 space-y-1 text-sm text-slate-300">
          <a href={CONTACT.phoneHref} data-testid="footer-phone" className="block hover:text-white">{CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="block hover:text-white">{CONTACT.email}</a>
          <div>Support {CONTACT.hours}</div>
        </div>
      </div>
      <div className="lg:col-span-3 lg:col-start-7">
        <div className={head}>Tools</div>
        {TOOLS.map((t) => (
          <button key={t.id} data-testid={`footer-tool-${t.id}`} onClick={() => openTool(t.id)} className={item}>{t.label}</button>
        ))}
      </div>
      <div className="lg:col-span-3">
        <div className={head}>Company</div>
        {COMPANY.map((c) => (
          <button key={c.id} data-testid={`footer-link-${c.id}`} onClick={() => scrollToId(c.id)} className={item}>{c.label}</button>
        ))}
        <Link to="/my-orders" data-testid="footer-my-orders" className={item}>My Orders</Link>
        <Link to="/admin" data-testid="footer-admin-link" className={item}>Admin</Link>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-400">
        <span>© {new Date().getFullYear()} {CONTACT.business}. All rights reserved.</span>
        <span>Owner {CONTACT.owner}</span>
      </div>
      <p className="max-w-[1440px] mx-auto px-5 sm:px-8 pb-8 text-xs text-slate-400">
        {CONTACT.business} uses AI to edit and create pictures. Results may vary. Credits for swaps that fail are refunded automatically.
      </p>
    </div>
  </footer>
);
